import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import ButtonBase from '@material-ui/core/ButtonBase';
import {getTranslation} from "../../helpers/get-translation";
import {getImageFromRiddle} from "../../helpers/cloud-function/riddle-image";

const styles = theme => ({
	imageLogo: {
		width: "85%",
		height: "auto"
	},
	imageStar: {
		display: "block",
		margin: "0 auto",
		width: "75%"
	},
	imageComplete: {
		position: "absolute",
		right: "0",
		width: "25%",
		height: "auto",
		zIndex: 1,
	}
});


const starsPrefix = getTranslation("image_logo_starts_prefix");
const checkMark = getTranslation("image_logo_complete");
const almostEqual = getTranslation("image_logo_almost_guessed");
// const almostEqual = "static/images/logo-screen/almost_equal.png"; TODO

function Logo (props) {
	const { classes,
		img,
		imgSolved,
		points,
		isSolved,
		isAlmostGuessed,
		onClick } = props;

	const image = getImageFromRiddle({isSolved, img, imgSolved});

	const completeImage = isSolved ? checkMark : almostEqual;

	return (
		<div onClick={onClick}>
			{(isSolved || isAlmostGuessed) &&
			<img
				src={completeImage}
				className={classes.imageComplete}
				alt="checkMark"
			/>
			}
			<ButtonBase>
				<img src={image} className={classes.imageLogo} alt="logo" />
			</ButtonBase>
			{isSolved && points > 0 &&
			<div>
				<img
					src={`${starsPrefix}${points}.png`}
					className={classes.imageStar}
					alt={`stars-${points}`}
				/>
			</div>
			}
		</div>
	)
}

// solvedDate
// wikipediaUrl

Logo.propTypes = {
	gameType: PropTypes.string.isRequired,
	hintClue1: PropTypes.string,
	hintClue2: PropTypes.string,
	img: PropTypes.string.isRequired,
	imgSolved: PropTypes.string,
	riddleKey: PropTypes.string.isRequired,

	lp: PropTypes.number.isRequired,
	points: PropTypes.number.isRequired,
	wrongGuessTries: PropTypes.number,

	isSolved: PropTypes.bool,
	isAlmostGuessed: PropTypes.bool,

	classes: PropTypes.shape({
		imageLogo: PropTypes.string.isRequired,
		imageStar: PropTypes.string.isRequired,
		imageComplete: PropTypes.string.isRequired
	}).isRequired,

	onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(Logo);
